function GetQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	var context = "";
	if (r != null) context = r[2];
	reg = null;
	r = null;
	return context == null || context == "" || context == "undefined"
		? ""
		: context;
}

function GetQueryStringFromURL(src, name) { //截取参数  split方法

	if (src.indexOf("?") == -1)  return "";
    var url = src.split("?")[1]; //获取url中"?"符后的字串
	var theRequest = new Object();
		var strs = url.split("&");
		for (var i = 0; i < strs.length; i++) {
			theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
		}
	return theRequest[name];
}

function imgOnError(e) {
	e.target.src = "../../static/images/default.png";
}

export { GetQueryString, GetQueryStringFromURL, imgOnError };



// WEBPACK FOOTER //
// ./src/utils/util.js